import { render, staticRenderFns } from "./ReportCreateModal.vue?vue&type=template&id=04c739f0"
import script from "./ReportCreateModal.vue?vue&type=script&lang=js"
export * from "./ReportCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports